@if (shouldShowButton()) {
  <div class="text-center">
    <button mat-raised-button
            color="primary"
            (click)="handleMakePayoutClick()"
            data-testid="make-payout-button">
      Make Payout
    </button>
  </div>
}
